var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"src":"media/bg/bg-10.jpg","elevate-on-scroll":"","app":"","fixed":"","color":"transparent","flat":"","dense":""}},[_c('walletButton',{staticStyle:{"flex-basis":"100%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }